import { usePortalApi } from "../api-access/use-portal-api";

export function useUserProfile() {
  return usePortalApi(client => client.getUserProfile(), ["getUserProfile"]);
}
